import CotizadorFlux from "@pages/producto/flux/CotizadorFlux";
import CotizadorMercader from "@pages/producto/mercader/CotizadorMercader";

export type CotizadorV2Type = "credito_simple";

/**
 * Cotizadores migrados al diseño nuevo, por tipo de producto y tenant. Se agregan aquí conforme se
 * migran; mientras un tenant no esté en la lista sigue usando su cotizador de `Cotizadores`.
 */
export const cotizadoresV2PorTipo: Record<CotizadorV2Type, Record<string, React.FC>> = {
  credito_simple: {
    flux: CotizadorFlux,
    mercader: CotizadorMercader,
  },
};

/** Ruta del cotizador legacy al que se regresa cuando el tenant todavía no tiene cotizador v2. */
export const COTIZADORES_LEGACY_PATHS: Record<CotizadorV2Type, string> = {
  credito_simple: "/solicita_tu_credito",
};
